// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sup-fin-main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}

.sup-fin-search-label {
  font-size: 22px;
  margin-bottom: 0.6rem;
}

.sup-fin-popup {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.6);
  z-index: 9999;
}

.sup-fin-card {
  background-color: #fff;
  width: fit-content;
  min-width: 360px;
  overflow-y: auto;
}

.sup-fin-card-header-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.5rem;
}

.sup-fin-close-btn {
  background-color: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}

.sup-fin-info-container {
  max-width: 360px;
}

.sup-fin-info-container h4 {
  padding: 0.75rem;
  margin: 0;
  background: #f05a9b;
  color: #fff;
  font-size: 16px;
}

.sup-fin-info-body {
  margin: 0.25rem 1rem 2rem 1rem;
}

.sup-fin-text-container p {
  font-size: 15px;
  line-height: 1.1rem;
}

.sup-fin-text-container label, .sup-fin-info-body label {
  font-size: 12px;
  margin-bottom: 0;
  margin-right: 10px;
}

.sup-fin-files-container button, .sup-fin-files-container a {
  background-color: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  font-size: 12px;
  color: #f05a9b;
  margin-right: 10px;
}

.sup-fin-files {
  margin-bottom: 8px;
}

.sup-fin-files-container label {
  font-size: 12px;
  margin-bottom: 0;
  min-width: 100px;
}

#sup-fin-disable-download-link {
  pointer-events: none;
  color: #dcdcdc;
  cursor: not-allowed;
}

.sup-fin-files-container button i.fa, .sup-fin-files-container a i.fa  {
  margin-left: 6px;
}

.sup-fin-files-container button:disabled {
  color: #dcdcdc;
  cursor: not-allowed;
}

.sup-fin-info-container select {
  font-size: 14px;
  margin-top: 0.5rem;
  padding: 0.25rem 0.5rem;
  appearance: none;
  outline: none;
  cursor: pointer;
  border: 1px solid #dcdcdc;
}

.sup-fin-view-img-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.6);
}

.sup-fin-view-img-card {
  background-color: #fff;
  max-width: 80vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sup-fin-view-img-card label {
  min-width: unset;
}

.sup-fin-view-img {
  max-width: 75vw;
  max-height: 75vh;
  height: auto;
  width: auto;
  object-fit: contain;
}

.sup-fin-info-body input {
  display: block;
  padding: 0.5rem 0.75rem;
  border: 1px solid #dcdcdc;
  margin-bottom: 10px;
  max-width: 300px;
  font-size: 15px;
  border-radius: 0;
  outline: none;
}

.sup-fin-submit-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
  border-top: 1px solid #dcdcdc;
}

button.sup-fin-submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  min-height: 40px;
  text-align: center;
  font-size: 14px;
  border: none;
  background-color: #f05a9b;
  color: #fff;
  outline: none;
}

.sup-fin-error-txt {
  color: red;
  font-size: 13px;
  margin-bottom: 2px;
}

.sup-fin-success-txt {
  color: green;
  font-size: 14px;
  margin-bottom: 2px;
}

p.sup-fin-error-label {
  margin: 0.5rem 0 0 0;
  color: red;
  font-size: 13px;
}

.sup-fin-submit-loading {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}

@media (min-width: 1080px) {
  .sup-fin-body-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .sup-fin-info-container {
    max-width: 360px;
    border: 1px solid #dcdcdc;
    margin: 0 0.5rem 0.5rem 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/supplierFinance.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,KAAK,iCAAiC,EAAE;AAC1C;AACA;EACE,KAAK,iCAAiC,EAAE;AAC1C;;AAEA;EACE;IACE,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;EAChC;AACF","sourcesContent":[".sup-fin-main-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100vh;\n}\n\n.sup-fin-search-label {\n  font-size: 22px;\n  margin-bottom: 0.6rem;\n}\n\n.sup-fin-popup {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.6);\n  z-index: 9999;\n}\n\n.sup-fin-card {\n  background-color: #fff;\n  width: fit-content;\n  min-width: 360px;\n  overflow-y: auto;\n}\n\n.sup-fin-card-header-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0.5rem;\n}\n\n.sup-fin-close-btn {\n  background-color: transparent;\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n\n.sup-fin-info-container {\n  max-width: 360px;\n}\n\n.sup-fin-info-container h4 {\n  padding: 0.75rem;\n  margin: 0;\n  background: #f05a9b;\n  color: #fff;\n  font-size: 16px;\n}\n\n.sup-fin-info-body {\n  margin: 0.25rem 1rem 2rem 1rem;\n}\n\n.sup-fin-text-container p {\n  font-size: 15px;\n  line-height: 1.1rem;\n}\n\n.sup-fin-text-container label, .sup-fin-info-body label {\n  font-size: 12px;\n  margin-bottom: 0;\n  margin-right: 10px;\n}\n\n.sup-fin-files-container button, .sup-fin-files-container a {\n  background-color: transparent;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  cursor: pointer;\n  font-size: 12px;\n  color: #f05a9b;\n  margin-right: 10px;\n}\n\n.sup-fin-files {\n  margin-bottom: 8px;\n}\n\n.sup-fin-files-container label {\n  font-size: 12px;\n  margin-bottom: 0;\n  min-width: 100px;\n}\n\n#sup-fin-disable-download-link {\n  pointer-events: none;\n  color: #dcdcdc;\n  cursor: not-allowed;\n}\n\n.sup-fin-files-container button i.fa, .sup-fin-files-container a i.fa  {\n  margin-left: 6px;\n}\n\n.sup-fin-files-container button:disabled {\n  color: #dcdcdc;\n  cursor: not-allowed;\n}\n\n.sup-fin-info-container select {\n  font-size: 14px;\n  margin-top: 0.5rem;\n  padding: 0.25rem 0.5rem;\n  appearance: none;\n  outline: none;\n  cursor: pointer;\n  border: 1px solid #dcdcdc;\n}\n\n.sup-fin-view-img-container {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.6);\n}\n\n.sup-fin-view-img-card {\n  background-color: #fff;\n  max-width: 80vw;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.sup-fin-view-img-card label {\n  min-width: unset;\n}\n\n.sup-fin-view-img {\n  max-width: 75vw;\n  max-height: 75vh;\n  height: auto;\n  width: auto;\n  object-fit: contain;\n}\n\n.sup-fin-info-body input {\n  display: block;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #dcdcdc;\n  margin-bottom: 10px;\n  max-width: 300px;\n  font-size: 15px;\n  border-radius: 0;\n  outline: none;\n}\n\n.sup-fin-submit-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 1rem;\n  border-top: 1px solid #dcdcdc;\n}\n\nbutton.sup-fin-submit-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 90%;\n  min-height: 40px;\n  text-align: center;\n  font-size: 14px;\n  border: none;\n  background-color: #f05a9b;\n  color: #fff;\n  outline: none;\n}\n\n.sup-fin-error-txt {\n  color: red;\n  font-size: 13px;\n  margin-bottom: 2px;\n}\n\n.sup-fin-success-txt {\n  color: green;\n  font-size: 14px;\n  margin-bottom: 2px;\n}\n\np.sup-fin-error-label {\n  margin: 0.5rem 0 0 0;\n  color: red;\n  font-size: 13px;\n}\n\n.sup-fin-submit-loading {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border: 3px solid rgba(255,255,255,.3);\n  border-radius: 50%;\n  border-top-color: #fff;\n  animation: spin 1s ease-in-out infinite;\n  -webkit-animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to { -webkit-transform: rotate(360deg); }\n}\n@-webkit-keyframes spin {\n  to { -webkit-transform: rotate(360deg); }\n}\n\n@media (min-width: 1080px) {\n  .sup-fin-body-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  .sup-fin-info-container {\n    max-width: 360px;\n    border: 1px solid #dcdcdc;\n    margin: 0 0.5rem 0.5rem 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
